import React from "react";
import "./Button.scss";

interface IButtonProps {
    children?: React.ReactNode;
    onClick?: () => void;
    buttonStyle?: string;
    id?: string;
}

const Button: React.FC<IButtonProps> = ({ children, onClick, buttonStyle, id }) => {
    buttonStyle = buttonStyle ?? "btn--primary";
    return (
        <button className={`btn ${buttonStyle}`} onClick={onClick} id={id}>
            {children}
        </button>
    );
};

export default Button;
